import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/master',
    pathMatch: 'full'
  },
  {
    path: 'master',
    loadChildren: () => import('./master/master.module').then(m => m.MasterModule)
  },
  {
    path: 'afro-gift',
    loadChildren: () => import('./afrogift/afrogift.module').then(m => m.AfrogiftModule)
  },
  {
    path: 'exambly',
    loadChildren: () => import('./exambly/exambly.module').then(m => m.ExamblyModule)
  },
  {
    path: 'w3school',
    loadChildren: () => import('./wschool/wschool.module').then(m => m.WschoolModule)
  },
  {
    path: 'uzor',
    loadChildren: () => import('./uzor/uzor.module').then(m => m.UzorModule)
  },
  {
    path: 'introduction-to-computational-thinking-and-data-science',
    loadChildren: () => import('./ctds/ctds.module').then(m => m.CtdsModule)
  },
  {
    path: 'jamb',
    loadChildren: () => import('./jamb/jamb.module').then(m => m.JambModule)
  },
  {
    path: 'waec',
    loadChildren: () => import('./waec/waec.module').then(m => m.WaecModule)
  },
  {
    path: 'donate',
    loadChildren: () => import('./donate/donate.module').then(m => m.DonateModule)
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
